// extracted by mini-css-extract-plugin
export default {"hover-wrapper":"_1xemi","hoverWrapper":"_1xemi"};